/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.CancellationReason_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.CancellationReason domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum CancellationReason_ {
   /// <summary>
   ///    (unknown)
   /// </summary>
   Unknown = 0,
   /// <summary>
   ///   Time Consuming (time)
   /// </summary>
   TimeConsuming = 1,
   /// <summary>
   ///   Cost (cost)
   /// </summary>
   Cost = 2,
   /// <summary>
   ///   Product Bugs (bugs)
   /// </summary>
   ProductBugs = 3,
   /// <summary>
   ///   Other (please explain) ... (other)
   /// </summary>
   Other = 4
}

export const CancellationReasons: CancellationReason[] = [
   {
      code: CancellationReason_.Unknown,
      literal: 'Unknown',
      description: '',
      shortDescription: 'unknown',
      listPriority: 0,

      typeName: "CancellationReason"
   },
   {
      code: CancellationReason_.TimeConsuming,
      literal: 'TimeConsuming',
      description: 'Time Consuming',
      shortDescription: 'time',
      listPriority: 0,

      typeName: "CancellationReason"
   },
   {
      code: CancellationReason_.Cost,
      literal: 'Cost',
      description: 'Cost',
      shortDescription: 'cost',
      listPriority: 0,

      typeName: "CancellationReason"
   },
   {
      code: CancellationReason_.ProductBugs,
      literal: 'ProductBugs',
      description: 'Product Bugs',
      shortDescription: 'bugs',
      listPriority: 0,

      typeName: "CancellationReason"
   },
   {
      code: CancellationReason_.Other,
      literal: 'Other',
      description: 'Other (please explain) ...',
      shortDescription: 'other',
      listPriority: 0,

      typeName: "CancellationReason"
   }
]

export class CancellationReason implements IDomainModel {
   code: CancellationReason_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: CancellationReason_): CancellationReason {
      return CancellationReasons.find(d => d.code === code)
   }
}
